import type { AgentSessionsResult } from './types';
import { useAgentSessionsData } from './useAgentSessionsData';

export const useAgentSessions = (): AgentSessionsResult => useAgentSessionsData();
